<!--历史补录-->
<template>
  <div class="archiverstype">
    <div class="con">
      <div class="left-tree">
        <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
      </div>
      <div class="right-table">
        <div class="top-table">
          <div class="Files-top">
            <div class="ic-left">
              <span>历史补录</span>
            </div>
            <div class="btns">
              <el-button type="primary" size="mini" v-if="flag" @click="flag = !flag">转换为编辑状态</el-button>
              <el-button type="success" size="mini" v-else @click="newAddSuperior">确认编辑</el-button>
            </div>
          </div>
          <div class="span" style="display: flex;margin: 20px 0; ">
            <div class="input-small myinput" style="margin-right: 20px;">
              <el-select v-model="timeType" placeholder="请选择" style="width: 160px;" @change="timeType_fn">
                <el-option label="日" value="DAY"> </el-option>
                <el-option label="月" value="MON"> </el-option>
              </el-select>
            </div>
            <div class="input-small">
              <el-date-picker class="picker" v-model="dateValue" type="date" placeholder="请选择日期"
                value-format="timestamp" v-if="dateType == 'DAY'" :picker-options="pickerOptions"></el-date-picker>
              <el-date-picker class="picker" v-model="dateValue" type="month" placeholder="请选择月份"
                value-format="timestamp" v-if="dateType == 'MON'" :picker-options="pickerOptions"></el-date-picker>
            </div>
            <el-button type="primary" plain style="margin-left: 10px;" @click="getList">查询</el-button>
          </div>
          <el-table :data="treeTableList" height="90" stripe style="width: 100%;margin-top: 10px;" border>
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column prop="variablename" label="名称" width="260" />
            <el-table-column prop="max" label="最大值" align="right" />
            <el-table-column prop="maxtime" label="最大值时间" align="center" />
            <el-table-column prop="min" label="最小值" align="right" />
            <el-table-column prop="mintime" label="最小值时间" align="center" />
            <el-table-column prop="next" label="平均值" align="right" />
            <el-table-column prop="value0000" label="24点" align="right" />

          </el-table>
        </div>
        <div class="bottom-table">

          <div class="my-table">
            <el-table :data="attributesList" :height="heights" stripe style="width: 100%;margin-top: 10px;" border>
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>

              <el-table-column label="时/分" align="center">
                <template slot-scope="scope">
                  <span
                    style="background: #368ED9;position: absolute;left: 0;top: 0;bottom: 0;right: 0;color:#fff;     line-height: 45px;">
                    {{scope.row.time}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="0分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'00']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'00')" type="text"
                    v-model="TableList['value'+scope.row.value+'00']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="5分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'05']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'05')" type="text"
                    v-model="TableList['value'+scope.row.value+'05']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="10分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'10']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'10')" type="text"
                    v-model="TableList['value'+scope.row.value+'10']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="15分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'15']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'15')" type="text"
                    v-model="TableList['value'+scope.row.value+'15']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="20分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'20']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'20')" type="text"
                    v-model="TableList['value'+scope.row.value+'20']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="25分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'25']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'25')" type="text"
                    v-model="TableList['value'+scope.row.value+'25']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="30分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'30']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'30')" type="text"
                    v-model="TableList['value'+scope.row.value+'30']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="35分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'35']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'35')" type="text"
                    v-model="TableList['value'+scope.row.value+'35']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="40分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'40']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'40')" type="text"
                    v-model="TableList['value'+scope.row.value+'40']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="45分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'45']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'45')" type="text"
                    v-model="TableList['value'+scope.row.value+'45']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="50分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'50']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'50')" type="text"
                    v-model="TableList['value'+scope.row.value+'50']">
                </template>
              </el-table-column>
              <el-table-column prop="propertyName" width="140" label="55分" align="center">
                <template slot-scope="scope">
                  <span v-if="flag">{{TableList['value'+scope.row.value+'55']}}</span>
                  <input v-else @change="inputFn('value'+scope.row.value+'55')" type="text"
                    v-model="TableList['value'+scope.row.value+'55']">
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import elUnitTree from '@/components/module/newTree/elDeviceTree2.vue'
  import elIconBtn from '@/components/module/iconBtns.vue'
  import {statementVariableTree} from "@/api/newReport";
  import request from "@/api/http.js";
  export default {
    //inject: ['reload'],
    components: {
      elIconBtn,
      elUnitTree
    },

    data () {
      return {
        flag: true,// 编辑
        params: {},//搜索数据
        deviceName: '永宁机电补偿回路数显表.A相电压',//设备名
        virtualDeviceList: [],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
        },
        timeType: "DAY",
        dateValue: new Date().getTime(),
        dateType: "DAY",
        heights: document.getElementById('app').clientHeight-390,
        defaultProps: {
          children: 'children',
          label: 'typeName'
        },
        filterText: "",
        treeList: [],
        treeTableList: [{}],
        attributesList: [],
        editSuperiorShow: false, //编辑上级类型
        editSuperiorForm: {
          date: '',
          typeCode: '',
          typeName: '',
          editable: '',
          typeEnum: ''
          // isRank: '',
        },
        propertyShow: false,
        editPropertyForm: {
          propertyName: '',
          valueType: '',
          defaultValue: '',
          editable: '',
          nullable: ''
        },
        addSuperiorShow: false,
        addSuperiorForm: {
          typeName: '',
          typeCode: '',
          typeEnum: "0"
          // isRank: '0'
        },
        addType: '', //添加的类型
        addPropertyShow: false,

        search: '',
        getEntityTypeList: [], //树数据

        addRules: {
          typeName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          typeCode: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],

        },

        isShow: true,
        typeEnum: 0,
        TableList: {},
        attributesListCopy: [],//编辑数据
      }
    },

    mounted () {
      //初始化数据 
      this.attributesList=[];
      for(let i=0;i<24;i++) {
        this.attributesList.push({
          time: i+'时',
          value: i>9? i:'0'+i,
          propertyName: '0'
        })
      }
      this.virtualDeviceList=[]
      statementVariableTree({"unitId": this.$store.unitStore.getters.getNowUnit.id}).then(res => {
        if(res.code==200) {
          this.handleData(res);
          this.getList();
        }
      })
    },

    methods: {
      inputFn (v) {
        this.attributesListCopy.map((a,i) => {
          if(a.dataKey==v) {
            this.attributesListCopy.splice(i,1)
          }
        })
        this.attributesListCopy.push({
          "dataKey": v,
          "dataValue": this.TableList[v]
        })
        console.log(v,'vv');
      },
      editFn (v) {
        // 
        // this.params
        var data={
          "deviceName": this.params.deviceName,
          "selectTime": this.params.selectTime,
          "timeType": this.params.timeType,
          "updateHistoriiesDataDTOS": this.attributesListCopy
        }
        console.log(data);
        request({url: "/replenish/updateHistoriyData",method: "put",data}).then(res => {
          console.log(res);
          if(res.code==200) {
            this.attributesListCopy=[]
            this.$message({showClose: true,message: '修改成功',type: 'success'});
            this.getList()
          }
        })
      },
      //处理企业数据
      handleData (data) {
        data=JSON.parse(JSON.stringify(data).replace(/appTypes/g,'ChildDatas').replace(/groupName/g,"Name").replace(/groupIdAndName/g,"Content").replace(/groupId/g,"Id").replace(/appTypeInfo/g,"Content").replace(/appName/g,"Name"))

        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.ChildDatas.length!=0) {

                getStr(row.ChildDatas)
              } else {
                row.ChildDatas=row.Content.groups
              }
            })
          }
          getStr([data.data])
        }
        recursiveFunction()



        // var abc = 	[a.data].filter(item => item.Content.groups.hasOwnProperty('groupIdAndName'))

        this.virtualDeviceList=[data.data];

      },
      checkFun (val) {
        if(val[0].Content&&val[0].Content.variableName) {
          this.deviceName=val[0].Content.variableName;
          console.log(this.deviceName);
        }

      },
      getList () {
        if(!this.dateValue) {
          this.$message({showClose: true,message: '请选择时间',type: 'info'});
        }
        var params={deviceName: this.deviceName,selectTime: this.dateValue,timeType: this.timeType};
        this.params=params;
        request({url: "/replenish/getHistoriyData",method: "get",params}).then(res => {
          if(res.code==200) {
            this.treeTableList=[res.data]
            this.TableList=res.data
          }
        })
      },
      //时间类型变化
      timeType_fn (val) {
        this.dateType=val
        this.dateValue=""
      },

      //筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.name.indexOf(value)!==-1;
      },

      // 确认编辑
      newAddSuperior () {

        this.flag=true;
        if(!this.attributesListCopy.length) {
          this.$message({showClose: true,message: '未修改数据',type: 'info'});
          return
        }
        this.editFn()
        console.log(this.attributesListCopy);
      },

    }
  }
</script>

<style scoped lang="scss">
  .archiverstype {
    .con {
      width: 100%;
      height: 100%;
      // background-color: #fff;
      box-sizing: border-box;
      display: flex;

      .left-tree {
        width: 300px;
        height: 100%;
        background-color: #fff;
        margin-right: 8px;
        padding: 12px;
        box-sizing: border-box;

        .btns {
          margin-top: 12px;
          margin-bottom: 5px;
        }

        /deep/.el-button {
          padding: 6px 11px !important;
        }
      }

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .right-table {
        width: calc(100% - 308px);
        height: 100%;

        .top-table {
          width: 100%;
          height: 240px;
          background-color: #fff;
          padding: 12px 20px;
          box-sizing: border-box;
          margin-bottom: 8px;
        }

        .bottom-table {
          width: 100%;
          height: calc(100% - 246px);
          background-color: #fff;
          box-sizing: border-box;
          padding: 12px 20px;
        }
      }
    }
  }
</style>